export default __webpack_public_path__ + "static/media/cube-pattern-dark-mode.16526cde.png";